import { createContext, useContext } from 'react';

export type OrgScopedDomain = {
  id: string;
  name: string;
  slug: string;
  subdomains: Array<{ id: string; name: string }>;
};

export type OrgScopedDomainsContextType = {
  domains: OrgScopedDomain[];
  loading: boolean;
};

const OrgScopedDomainsContext = createContext<OrgScopedDomainsContextType>({
  domains: [],
  loading: false,
});

export const useOrgScopedDomains = () => useContext(OrgScopedDomainsContext);

export default OrgScopedDomainsContext;
